'use strict'

/**
 * Name: Home > Avatar Visual
 * Page: /
 * ===========================================
 */

const IMG = require('@/assets/images/home_bg2.jpg')

function canvasImageCover(canvas, img, x = 0, y = 0, w, h, offsetX = 0.5, offsetY = 0.5) {
  if (!w) w = canvas.width
  if (!h) h = canvas.height

  // keep bounds [0.0, 1.0]
  if (offsetX < 0) offsetX = 0
  if (offsetY < 0) offsetY = 0
  if (offsetX > 1) offsetX = 1
  if (offsetY > 1) offsetY = 1

  var iw = img.naturalWidth || img.width
  let ih = img.naturalHeight || img.height
  let r = Math.min(w / iw, h / ih)
  let nw = iw * r // new prop. width
  let nh = ih * r // new prop. height
  let cx
  let cy
  let cw
  let ch
  let ar = 1

  // decide which gap to fill
  if (nw < w) ar = w / nw
  if (nh < h) ar = h / nh
  nw *= ar
  nh *= ar

  // calc source rectangle
  cw = iw / (nw / w)
  ch = ih / (nh / h)

  cx = (iw - cw) * offsetX
  cy = (ih - ch) * offsetY

  // make sure source rectangle is valid
  if (cx < 0) cx = 0
  if (cy < 0) cy = 0
  if (cw > iw) cw = iw
  if (ch > ih) ch = ih

  // console.log('im', cx, cy, cw, ch,  x, y, w, h)

  return {
    cx, cy, cw, ch, x, y, w, h
  }
}

export const AvatarCanvasOptions = {
  speed: 4,
  delay: false
}

export default class AvatarCanvas {
  constructor(el, options = {}) {
    this.REQUESTID = false
    this.ANIMATION_CHECK = false
    this.ANIMATION_FRAME = 0
    this.options = Object.assign({}, AvatarCanvasOptions, options)

    this.canvas = document.getElementById(el)
    this.context = this.canvas.getContext('2d')
    this.w = this.canvas.width = window.innerWidth
    this.h = this.canvas.height = window.innerHeight

    this.index = 2
    this.randIndex = 20
    this.renderCount = 20
    this.imageCover = {}

    this.resourceLoaded = false
    this.resourceLoadStatus = {
      bgImage: false,
      manualStart: false
    }

    this.bgImage = new Image()
    this.bgImage.src = IMG
    this.bgImage.onload = () => {
      this.resourceLoadStatus.bgImage = true
      this.imageCover = canvasImageCover(this.canvas, this.bgImage, 0, 0)
      this.checkResouceLoaded()
    }

    this.fakeCanvas = document.createElement('canvas')
    this.fakeCanvas.width = this.w
    this.fakeCanvas.height = this.h
    this.fakeCtx = this.fakeCanvas.getContext('2d')

    this.pixel = false
  }

  animeStart() {
    this.resourceLoadStatus.manualStart = true
    this.checkResouceLoaded()
  }

  checkResouceLoaded() {
    const status = Object.keys(this.resourceLoadStatus).every(key => this.resourceLoadStatus[key])
    if (status) {
      this.resourceLoaded = true
      const { cx, cy, cw, ch, x, y, w, h } = this.imageCover
      this.fakeCtx.drawImage(this.bgImage, cx, cy, cw, ch, x, y, w, h)
      this.pixel = this.fakeCtx.getImageData(0, 0, this.w, this.h)
      this.init()
    }
  }

  init() {
    if (this.options.delay) {
      setTimeout(() => {
        this.animationLoop()
      }, this.options.delay)
    } else {
      this.animationLoop()
    }
  }

  rand(min = -1, max = 1) {
    return Math.floor(Math.random() * (max + 1 - min)) + min
  }

  render() {
    if (this.index < 140) {
      this.index = this.index * 2
    }
    if (this.index > 140) {
      this.index = 140
    }

    const opacity = (this.index < 140) ? 1 : 0.85

    let max = Math.max(this.w, this.h)
    let size = Math.floor(max / this.index)

    for (let x = 0; x < (this.w / size); x++) {
      for (let y = 0; y < (this.h / size); y++) {
        const index = ((x * size) + (y * size * this.w)) * 4
        const data = this.pixel.data
        const rgba = `rgba(${data[index + 0]}, ${data[index + 1]}, ${data[index + 2]}, ${opacity})`
        this.context.fillStyle = rgba
        this.context.fillRect(
          (x * size) + (this.rand() * size),
          (y * size) + (this.rand() * size),
          size,
          size
        )
      }
    }
  }

  animationLoop() {
    this.ANIMATION_FRAME++
    if (this.ANIMATION_FRAME > this.options.speed && !this.ANIMATION_CHECK) {
      this.ANIMATION_FRAME = 0
      this.render()
    }
    if (!this.ANIMATION_CHECK) {
      this.REQUESTID = window.requestAnimationFrame(this.animationLoop.bind(this))
    }
  }

  animationStop() {
    this.ANIMATION_CHECK = true
    if (this.REQUESTID) {
      window.cancelAnimationFrame(this.REQUESTID)
    }
  }

  animationStart() {
    this.ANIMATION_CHECK = false
    if (this.options.delay) {
      setTimeout(() => {
        this.animationLoop()
      }, this.options.delay)
    } else {
      this.animationLoop()
    }
  }

  destroy() {
    this.animationStop()
  }
}
